import { Static, Type } from '@sinclair/typebox'
import { BaseModelSchema } from '../common'
import { ApId } from '../common/id-generator'
import { McpTool, McpToolType } from './tools/mcp-tool'

export type McpId = ApId

export const Mcp = Type.Object({
    ...BaseModelSchema,
    name: Type.String(),
    projectId: ApId,
    token: ApId,
})

export type Mcp = Static<typeof Mcp>

export const McpWithTools = Type.Composite([
    Mcp,
    Type.Object({
        tools: Type.Array(McpTool),
    }),
])


const MAX_TOOL_NAME_LENGTH = 60


export const mcpToolNaming = {
    fixTool: (name: string, id: string, type: McpToolType) => {
        const spaceToReserve = id.length + 1
        const baseName = name.replace(/[\s/@-]+/g, '_')
        switch (type) {
            case McpToolType.FLOW:
                return `${baseName.slice(0, MAX_TOOL_NAME_LENGTH - spaceToReserve)}_${id}`
            case McpToolType.PIECE:{
                return `${baseName.slice(0, MAX_TOOL_NAME_LENGTH - spaceToReserve)}_${id}` 
            }
        }
    },
    fixProperty: (schemaName: string) => {
        return schemaName.replace(/[\s/@-]+/g, '_')
    },
}



export type McpWithTools = Static<typeof McpWithTools>

export enum STATUS_VARIANT {
    POSITIVE = 'Postive (Green)',
    NEGATIVE = 'Negative (Red)',
    NEUTRAL = 'Neutral (Gray)',
}

export const STATUS_COLORS: Record<STATUS_VARIANT, StatusColor> = {
    [STATUS_VARIANT.POSITIVE]: {
        color: '#e5efe7',
        textColor: '#28813e',
    },
    [STATUS_VARIANT.NEGATIVE]: {
        color: '#fbe2e3',
        textColor: '#dd111b',
    },
    [STATUS_VARIANT.NEUTRAL]: {
        color: '#f6f6f6',
        textColor: '#2c2c2c',
    },
}

export type StatusColor = {
    color: string
    textColor: string
}
